import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {openNavHelp} from '../../actions/navOptions';

class NavHelp extends Component {

  render() {
    const {openNavHelp} = this.props;

    return (
    <div className="map-nav__btn" onClick={openNavHelp}>
      <a href="#" className="btn btn-default btn-m show-map-page">
        <div className="icon-help" />
      </a>
      Help
    </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openNavHelp }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(NavHelp);


// WEBPACK FOOTER //
// ./src/containers/NavOptions/NavHelp.js